import { useSelector, useDispatch } from 'react-redux';
import FJModal from '../FJModal';
import FJActionModal from '../../../redux/action/FJActionModal';
import FJAutoSelectionNoticeModal from './FJAutoSelectionNoticeModal';

// 移动端自动选择图片提示
const FJAutoSelectionNoticeModalContainer = () => {
    const autoSelectionNoticeDisplay = useSelector(state => state.modals.autoSelectionNoticeDisplay);
    const dispatch = useDispatch();
    const onClose = () => {
        dispatch(FJActionModal.hideAutoSelectionNoticeModalAction());
    };
    return (
        <FJModal
            visible={autoSelectionNoticeDisplay}
            zIndex={1005}
            backgroundColor='transparent'
            boxShadow='none'
            maskStyle={{ backdropFilter: `blur(10px)` }}
        >
            <FJAutoSelectionNoticeModal onClose={onClose} />
        </FJModal>
    );
};
export default FJAutoSelectionNoticeModalContainer;
